
import React from "react";

import InputLabel from "./Layout/InputLabel";
import InputContainer from "./Layout/InputContainer";
import StyledText from "ae-base/Base/StyledText";

export default function AELabel(props){
	var schema = props.schema;
	var defaultValue = props.defaultValue;
	var contrast = props.contrast;

	return (
		<InputContainer inline={props.inline}>
			<InputLabel schema={schema} />
			<StyledText contrast={contrast} emphasized>
				{defaultValue}
			</StyledText>
		</InputContainer>
	);
}

import types from "./Layout/inputTypes";

AELabel.propTypes = types;
